import * as actionTypes from "../../actions/actionTypes";

const initState = {
  clicks: [],
  click: "",
  total: 0,
  fetchAdsLoading: false,
  fetchAdsError: null,
  filtersApplied: false,
  filtersReset: false,
};

const adsReducer = (state = initState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ADS_START:
      return {
        ...state,
        fetchAdsLoading: true,
      };
    case actionTypes.FETCH_ADS_SUCCESS:
      return {
        ...state,
        fetchAdsLoading: false,
        clicks: action.clicks,
        total: action.total,
        filtersReset: false,
      };
    case actionTypes.FETCH_ADS_FAILED:
      return {
        ...state,
        total: 0,
        fetchAdsLoading: false,
        fetchAdsError: action.error,
      };

    // FILTER
    case actionTypes.FILTER_ADS_START:
      return {
        ...state,
        filtersLoading: true,
      };
    case actionTypes.FILTER_ADS_SUCCESS:
      return {
        ...state,
        filtersLoading: false,
        filtersApplied: true,
      };
    case actionTypes.FILTER_ADS_RESET:
      return {
        ...state,
        filtersLoading: false,
        filtersApplied: false,
        filtersReset: true,
      };

    default:
      return state;
  }
};

export default adsReducer;
